// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralAssetService = {};
// console.log("🚀 ~ CollateralAssetService:", CollateralAssetService);

CollateralAssetService.postCollateralAsset = function (data) {
  return lossClient({
    url: "/CollateralAsset/add",
    method: "post",
    data: data,
  });
};

CollateralAssetService.getCollateralAssetList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  
  return lossClient({
    url:
      "/CollateralAsset/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralAssetService.getCollateralAssetApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: CollateralAssetService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: CollateralAssetService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/CollateralAsset/ApprovalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralAssetService.putCollateralAssetApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { userId: data.userId, Note: data.note, CollateralAssetId: data.id }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note, CollateralAssetId: data.id }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, Note: data.note, CollateralAssetId: data.id }
      : { userId: data.userId, Note: data.note, CollateralAssetId: data.id };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/CollateralAsset/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.assetTypeId,
    },
    data: requestDataValidation,
  });
};

CollateralAssetService.putCollateralAssetRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    CollateralAssetId: data.CollateralAssetId,
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/CollateralAsset/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.AssetTypeId,
    },
    data: bodyRequest,
  });
};

CollateralAssetService.getCollateralAssetDetail = function (data) {
  return lossClient({
    url: `/CollateralAsset/${data.id}`,
    method: "get",
  });
};

CollateralAssetService.updateCollateralAsset = function (data) {
  // console.log("🚀 ~ data:", data);
  const { AssetTypeId, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/CollateralAsset/edit",
    method: "put",
    headers: {
      "x-requestId": data.AssetTypeId,
    },
    data: requestBody,
  });
};

CollateralAssetService.deleteCollateralAsset = function (data) {
  // console.log(
  //   "🚀 ~ CollateralAssetService.deleteCollateralAsset ~ data:",
  //   data
  // );
  const { AssetTypeId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/CollateralAsset/delete",
    method: "delete",
    headers: {
      "x-requestid": data.AssetTypeId,
    },
    data: requestBody,
  });
};

export default CollateralAssetService;
